import { Link, useLocation, useNavigate } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  usePageMeta("页面不存在 - 蜜月TV", "抱歉，你访问的页面不存在，请返回首页继续浏览蜜月TV精彩影视内容。");

  return (
    <div className="w-full px-4 md:px-8 py-20 md:py-28">
      <div className="max-w-xl mx-auto text-center">
        <p className="text-7xl md:text-9xl font-black text-primary-200 select-none">404</p>
        <h1 className="text-xl md:text-2xl font-black text-foreground-950 mt-4">
          您访问的页面不存在
        </h1>
        <p className="text-sm text-foreground-500 mt-3">
          页面可能已被移除，或链接输入有误。不妨回到首页，继续发现精彩影视内容。
        </p>
        <p className="mt-3 text-xs text-foreground-400 font-mono break-all">{location.pathname}</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <Link
            to="/"
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-4-line" /> 返回首页
          </Link>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-200 text-sm font-semibold text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-go-back-line" /> 返回上一页
          </button>
        </div>

        <div className="mt-10 flex items-center justify-center gap-4 flex-wrap text-sm">
          <Link to="/category/tv" className="text-primary-700 hover:text-primary-800">电视剧</Link>
          <span className="text-foreground-300">·</span>
          <Link to="/category/movie" className="text-primary-700 hover:text-primary-800">电影</Link>
          <span className="text-foreground-300">·</span>
          <Link to="/category/anime" className="text-primary-700 hover:text-primary-800">动漫</Link>
          <span className="text-foreground-300">·</span>
          <Link to="/news" className="text-primary-700 hover:text-primary-800">资讯</Link>
        </div>
      </div>
    </div>
  );
}